<template>
  <div class="background_index_contact">
    <div class="index_contact_text">
      <p style="font-size: 22px;font-weight: bolder">联系我们</p>
      <p>上海市黄浦区湖滨路222号企业天地1705-11室</p>
      <p>邮编 200021</p>
      <p>电话：（+86）21-61222888</p>
      <p>邮箱：ChinaPIM@sig.com</p>
    </div>
  </div>
  <Footer_m></Footer_m>
</template>

<script>
import Footer_m from "@/components/CN_mobile/Footer_m";
import {reactive, onMounted} from 'vue'

export default {
  name: 'Index_contact_m',
  components: {
    Footer_m,
  },
  setup() {

  }
}

</script>
<style scoped>
.background_index_contact {
  background-image: url("../../../assets/background/index_contact.jpg");
  height: 80vh;
  background-repeat: no-repeat;
  background-position: center;
  background-size: auto 100%;
  margin: 0;
  padding: 0 5vw;
}

.index_contact_text {
  text-align: center;
  padding-top: 30vh;
  padding-left: 5vw;
}

.index_contact_text p {
  font-size: 12px;
}

</style>